export default __webpack_public_path__ + "static/media/books-68.6c4a198d.jpg";